import "./DesignBatchBar.scss";
import MoveFolderIcon from "../icons/MoveFolderIcon";
import DeleteDesignIcon from "../icons/DeleteDesignIcon";
import CombineDesignsIcon from "../icons/CombineDesignsIcon";
import { DesignDto } from "../../generated/dashboard-client";
import { maxDesignPages } from "../../util/constants";
import BatchBar, { BatchAction } from "../common/BatchBar";

export interface DesignBatchBarProps {
  onOrganizeClick: () => void;
  onDeleteClick: () => void;
  onCombineClick: () => void;
  onCancelClick: () => void;
  selected: DesignDto[];
  selectedPageCount: number;
  isCombineLoading: boolean;
}

export default function DesignBatchBar({
  onOrganizeClick,
  onDeleteClick,
  onCombineClick,
  onCancelClick,
  selected,
  selectedPageCount,
  isCombineLoading,
}: DesignBatchBarProps) {
  const overMaxPages = selectedPageCount > maxDesignPages;
  const tooFewSelected = selected.length < 2;
  const combineDisabled = !isCombineLoading && (overMaxPages || tooFewSelected);
  const combineTooltip =
    !isCombineLoading && overMaxPages
      ? `You've reached the ${maxDesignPages} page maximum`
      : undefined;

  const actions: BatchAction[] = [
    {
      key: "move",
      icon: <MoveFolderIcon />,
      label: "Move",
      onClick: onOrganizeClick,
      liClassName: "batch-move",
    },
    {
      key: "delete",
      icon: <DeleteDesignIcon />,
      label: "Delete",
      onClick: onDeleteClick,
    },
    {
      key: "combine",
      icon: <CombineDesignsIcon />,
      label: "Combine",
      onClick: onCombineClick,
      disabled: combineDisabled,
      tooltip: combineTooltip,
      loading: isCombineLoading,
    },
  ];

  return <BatchBar actions={actions} onCancel={onCancelClick} />;
}
